function browser () {
  return {
    edgeVersion: getEdgeVersion(),
    isIE: isIE()
  };
}

export default browser;

export function getEdgeVersion () {
  const edgeVersion = Number.parseInt(
    /edge\/(\d+)/i.exec(navigator.userAgent)?.[1]
  );

  return Number.isNaN(edgeVersion) ? null : edgeVersion;
}

export function isIE () {
  let rv = -1;
  const ua = navigator.userAgent;

  if (navigator.appName === 'Microsoft Internet Explorer') {
    const re = /MSIE ([0-9]{1,}[\\.0-9]{0,})/.exec(ua);

    if (re !== null) {
      rv = Number.parseFloat(re[1]);
    }
  } else if (navigator.appName === 'Netscape') {
    const re = /Trident\/.*rv:([0-9]{1,}[\\.0-9]{0,})/.exec(ua);

    if (re !== null) {
      rv = Number.parseFloat(re[1]);
    }
  }

  return rv > 0;
}
